export default __webpack_public_path__ + "static/media/image1pro2.a19668cc.jpeg";